import React from "react";

import ACDropdown from "ac-components/ACDropdown";
import ACButton from "ac-components/ac-button/ACButton";
import CenterPanelIcon from "ac-components/ac-icons/CenterPanelIcon";
import CheckIcon from "ac-components/ac-icons/CheckIcon";
import SidePanelIcon from "ac-components/ac-icons/SidePanelIcon";

type ACModalPlacementMenuProps = {
  onPlacementChange: (placement: "right" | "center") => void;
  currentPlacement: "right" | "center";
};

const ACModalPlacementMenu: React.FC<ACModalPlacementMenuProps> = ({
  onPlacementChange,
  currentPlacement,
}) => {
  const dropdownItems = [
    {
      value: "right",
      label: "Side Panel",
      icon: <SidePanelIcon />,
      secondaryIcon: currentPlacement === "right" ? <CheckIcon /> : undefined,
    },
    {
      value: "center",
      label: "Center Panel",
      icon: <CenterPanelIcon />,
      secondaryIcon: currentPlacement === "center" ? <CheckIcon /> : undefined,
    },
  ];

  return (
    <ACDropdown
      onOptionClick={(p) => onPlacementChange(p as "right" | "center")}
      items={dropdownItems}
    >
      <ACButton type="ghost" iconOnly>
        {currentPlacement === "right" ? <SidePanelIcon /> : <CenterPanelIcon />}
      </ACButton>
    </ACDropdown>
  );
};

export default ACModalPlacementMenu;
